import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { createContext, useContext, useMemo, useReducer } from 'react';
import { notificationReducer } from "./helper";
var NotificationContext = /*#__PURE__*/createContext({
  notifications: [],
  addNotification: function addNotification() {},
  clearNotifications: function clearNotifications() {},
  getNotificationQueue: function getNotificationQueue() {
    return [];
  },
  removeNotification: function removeNotification() {},
  updateNotification: function updateNotification() {}
});
export var useNotificationContext = function useNotificationContext() {
  return useContext(NotificationContext);
};
export var NotificationProvider = function NotificationProvider(_ref) {
  var children = _ref.children,
    _ref$initialNotificat = _ref.initialNotifications,
    initialNotifications = _ref$initialNotificat === void 0 ? [] : _ref$initialNotificat;
  var _useReducer = useReducer(notificationReducer, initialNotifications),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    notifications = _useReducer2[0],
    dispatchNotifications = _useReducer2[1];
  var clearNotifications = function clearNotifications() {
    return dispatchNotifications({
      type: 'clear'
    });
  };
  var addNotification = function addNotification(item) {
    return dispatchNotifications({
      type: 'add',
      item: item
    });
  };
  var getNotificationQueue = function getNotificationQueue() {
    return notifications;
  };
  var removeNotification = function removeNotification(key) {
    return dispatchNotifications({
      type: 'remove',
      key: key
    });
  };
  var updateNotification = function updateNotification(item) {
    return dispatchNotifications({
      type: 'update',
      item: item
    });
  };
  var value = useMemo(function () {
    return {
      notifications: notifications,
      clearNotifications: clearNotifications,
      removeNotification: removeNotification,
      updateNotification: updateNotification,
      getNotificationQueue: getNotificationQueue,
      addNotification: addNotification
    };
  }, [notifications]);
  return /*#__PURE__*/React.createElement(NotificationContext.Provider, {
    value: value
  }, children);
};